import { defineStore } from 'pinia'

export const useMainStore = defineStore('main', {
    state: () => ({
        isLoggedIn: false,
        isLockOut: false,
        editObj:{},
        editObj1:{},
        editAppointment:{},


    }),
    getters: {
        // Define your getters here
        isAuthenticated: (state) => state.isLoggedIn,
        isLockAuthenticate: (state) => state.isLockOut,
        isGetEdit: (state) => state.editObj,
        isGetEdit1: (state) => state.editObj1,
        isEditAppointment: (state) => state.editAppointment,
       

    },
    actions: {
        login(isLoggedIn) {
            this.isLoggedIn = isLoggedIn;
            this.isLockOut = isLoggedIn;
            
        },
        lockOut() {
            this.editObj={};
        },
        logout() {
            this.editObj={};
        },
        
        GetEditObj(obj) {
            this.editObj = obj;
        },
        GetEditObj1(obj) {
            this.editObj1 = obj;
        },
        
        GetEditAppointment(obj) {
            this.editAppointment = obj;
        },
        
    },
    persist: true,
});
